/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as AppRouteRouteImport } from './_app/route'
import { Route as PublicRouteRouteImport } from './_public/route'
import { Route as AppIndexRouteImport } from './_app/index'
import { Route as AppAccountRouteImport } from './_app/account'
import { Route as AppHomeRouteImport } from './_app/home'
import { Route as AppNRouteImport } from './_app/n'
import { Route as AppSystemRouteRouteImport } from './_app/system/route'
import { Route as AppWelcomeRouteImport } from './_app/welcome'
import { Route as PublicContentRouteRouteImport } from './_public/_content/route'
import { Route as PublicMarketingRouteImport } from './_public/_marketing'
import { Route as PublicAuthRouteRouteImport } from './_public/auth/route'
import { Route as PublicErrorRouteImport } from './_public/error'
import { Route as AppTenantIdOrganizationSlugRouteRouteImport } from './_app/$tenantId.$organizationSlug/route'
import { Route as AppSystemToolRouteImport } from './_app/system/$tool'
import { Route as AppSystemOrganizationsRouteImport } from './_app/system/organizations'
import { Route as AppSystemRequestsRouteImport } from './_app/system/requests'
import { Route as AppSystemTenantsRouteImport } from './_app/system/tenants'
import { Route as AppSystemUsersRouteImport } from './_app/system/users'
import { Route as PublicContentDocsRouteRouteImport } from './_public/_content/docs/route'
import { Route as PublicMarketingAboutRouteImport } from './_public/_marketing/about'
import { Route as PublicMarketingAccessibilityRouteImport } from './_public/_marketing/accessibility'
import { Route as PublicMarketingContactRouteImport } from './_public/_marketing/contact'
import { Route as PublicMarketingFeaturesRouteImport } from './_public/_marketing/features'
import { Route as PublicMarketingSyncEngineRouteImport } from './_public/_marketing/sync-engine'
import { Route as PublicAuthAuthenticateRouteImport } from './_public/auth/authenticate'
import { Route as PublicAuthErrorRouteImport } from './_public/auth/error'
import { Route as PublicAuthMfaRouteImport } from './_public/auth/mfa'
import { Route as PublicAuthSignOutRouteImport } from './_public/auth/sign-out'
import { Route as PublicAuthUnsubscribedRouteImport } from './_public/auth/unsubscribed'
import { Route as AppTenantIdOrganizationSlugOrganizationRouteRouteImport } from './_app/$tenantId.$organizationSlug/organization/route'
import { Route as PublicContentDocsIndexRouteImport } from './_public/_content/docs/index'
import { Route as PublicContentDocsOperationsRouteImport } from './_public/_content/docs/operations'
import { Route as PublicContentDocsOverviewRouteImport } from './_public/_content/docs/overview'
import { Route as PublicContentDocsPagesRouteImport } from './_public/_content/docs/pages'
import { Route as PublicContentDocsSchemasRouteImport } from './_public/_content/docs/schemas'
import { Route as PublicMarketingLegalIndexRouteImport } from './_public/_marketing/legal.index'
import { Route as PublicMarketingLegalSubjectRouteImport } from './_public/_marketing/legal.$subject'
import { Route as PublicAuthEmailVerificationReasonRouteImport } from './_public/auth/email-verification.$reason'
import { Route as AppTenantIdOrganizationSlugOrganizationToolRouteImport } from './_app/$tenantId.$organizationSlug/organization/$tool'
import { Route as AppTenantIdOrganizationSlugOrganizationAttachmentsRouteImport } from './_app/$tenantId.$organizationSlug/organization/attachments'
import { Route as AppTenantIdOrganizationSlugOrganizationMembersRouteImport } from './_app/$tenantId.$organizationSlug/organization/members'
import { Route as AppTenantIdOrganizationSlugOrganizationSettingsRouteImport } from './_app/$tenantId.$organizationSlug/organization/settings'
import { Route as PublicContentDocsOperationsTableRouteImport } from './_public/_content/docs/operations_.table'
import { Route as PublicContentDocsPageSplatRouteImport } from './_public/_content/docs/page.$'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNRoute = AppNRouteImport.update({
  id: '/n',
  path: '/n',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSystemRouteRoute = AppSystemRouteRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWelcomeRoute = AppWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AppRouteRoute,
} as any)
const PublicContentRouteRoute = PublicContentRouteRouteImport.update({
  id: '/_content',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicMarketingRoute = PublicMarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicAuthRouteRoute = PublicAuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicErrorRoute = PublicErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AppTenantIdOrganizationSlugRouteRoute =
  AppTenantIdOrganizationSlugRouteRouteImport.update({
    id: '/$tenantId/$organizationSlug',
    path: '/$tenantId/$organizationSlug',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSystemToolRoute = AppSystemToolRouteImport.update({
  id: '/$tool',
  path: '/$tool',
  getParentRoute: () => AppSystemRouteRoute,
} as any)
const AppSystemOrganizationsRoute = AppSystemOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppSystemRouteRoute,
} as any)
const AppSystemRequestsRoute = AppSystemRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppSystemRouteRoute,
} as any)
const AppSystemTenantsRoute = AppSystemTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AppSystemRouteRoute,
} as any)
const AppSystemUsersRoute = AppSystemUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSystemRouteRoute,
} as any)
const PublicContentDocsRouteRoute = PublicContentDocsRouteRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => PublicContentRouteRoute,
} as any)
const PublicMarketingAboutRoute = PublicMarketingAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicMarketingRoute,
} as any)
const PublicMarketingAccessibilityRoute =
  PublicMarketingAccessibilityRouteImport.update({
    id: '/accessibility',
    path: '/accessibility',
    getParentRoute: () => PublicMarketingRoute,
  } as any)
const PublicMarketingContactRoute = PublicMarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicMarketingRoute,
} as any)
const PublicMarketingFeaturesRoute = PublicMarketingFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => PublicMarketingRoute,
} as any)
const PublicMarketingSyncEngineRoute =
  PublicMarketingSyncEngineRouteImport.update({
    id: '/sync-engine',
    path: '/sync-engine',
    getParentRoute: () => PublicMarketingRoute,
  } as any)
const PublicAuthAuthenticateRoute = PublicAuthAuthenticateRouteImport.update({
  id: '/authenticate',
  path: '/authenticate',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PublicAuthErrorRoute = PublicAuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PublicAuthMfaRoute = PublicAuthMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PublicAuthSignOutRoute = PublicAuthSignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PublicAuthUnsubscribedRoute = PublicAuthUnsubscribedRouteImport.update({
  id: '/unsubscribed',
  path: '/unsubscribed',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const AppTenantIdOrganizationSlugOrganizationRouteRoute =
  AppTenantIdOrganizationSlugOrganizationRouteRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AppTenantIdOrganizationSlugRouteRoute,
  } as any)
const PublicContentDocsIndexRoute = PublicContentDocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicContentDocsRouteRoute,
} as any)
const PublicContentDocsOperationsRoute =
  PublicContentDocsOperationsRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => PublicContentDocsRouteRoute,
  } as any)
const PublicContentDocsOverviewRoute =
  PublicContentDocsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => PublicContentDocsRouteRoute,
  } as any)
const PublicContentDocsPagesRoute = PublicContentDocsPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => PublicContentDocsRouteRoute,
} as any)
const PublicContentDocsSchemasRoute =
  PublicContentDocsSchemasRouteImport.update({
    id: '/schemas',
    path: '/schemas',
    getParentRoute: () => PublicContentDocsRouteRoute,
  } as any)
const PublicMarketingLegalIndexRoute =
  PublicMarketingLegalIndexRouteImport.update({
    id: '/legal/',
    path: '/legal/',
    getParentRoute: () => PublicMarketingRoute,
  } as any)
const PublicMarketingLegalSubjectRoute =
  PublicMarketingLegalSubjectRouteImport.update({
    id: '/legal/$subject',
    path: '/legal/$subject',
    getParentRoute: () => PublicMarketingRoute,
  } as any)
const PublicAuthEmailVerificationReasonRoute =
  PublicAuthEmailVerificationReasonRouteImport.update({
    id: '/email-verification/$reason',
    path: '/email-verification/$reason',
    getParentRoute: () => PublicAuthRouteRoute,
  } as any)
const AppTenantIdOrganizationSlugOrganizationToolRoute =
  AppTenantIdOrganizationSlugOrganizationToolRouteImport.update({
    id: '/$tool',
    path: '/$tool',
    getParentRoute: () => AppTenantIdOrganizationSlugOrganizationRouteRoute,
  } as any)
const AppTenantIdOrganizationSlugOrganizationAttachmentsRoute =
  AppTenantIdOrganizationSlugOrganizationAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => AppTenantIdOrganizationSlugOrganizationRouteRoute,
  } as any)
const AppTenantIdOrganizationSlugOrganizationMembersRoute =
  AppTenantIdOrganizationSlugOrganizationMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppTenantIdOrganizationSlugOrganizationRouteRoute,
  } as any)
const AppTenantIdOrganizationSlugOrganizationSettingsRoute =
  AppTenantIdOrganizationSlugOrganizationSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppTenantIdOrganizationSlugOrganizationRouteRoute,
  } as any)
const PublicContentDocsOperationsTableRoute =
  PublicContentDocsOperationsTableRouteImport.update({
    id: '/operations_/table',
    path: '/operations/table',
    getParentRoute: () => PublicContentDocsRouteRoute,
  } as any)
const PublicContentDocsPageSplatRoute =
  PublicContentDocsPageSplatRouteImport.update({
    id: '/page/$',
    path: '/page/$',
    getParentRoute: () => PublicContentDocsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/system': typeof AppSystemRouteRouteWithChildren
  '/auth': typeof PublicAuthRouteRouteWithChildren
  '/account': typeof AppAccountRoute
  '/home': typeof AppHomeRoute
  '/n': typeof AppNRoute
  '/welcome': typeof AppWelcomeRoute
  '/error': typeof PublicErrorRoute
  '/$tenantId/$organizationSlug': typeof AppTenantIdOrganizationSlugRouteRouteWithChildren
  '/docs': typeof PublicContentDocsRouteRouteWithChildren
  '/system/$tool': typeof AppSystemToolRoute
  '/system/organizations': typeof AppSystemOrganizationsRoute
  '/system/requests': typeof AppSystemRequestsRoute
  '/system/tenants': typeof AppSystemTenantsRoute
  '/system/users': typeof AppSystemUsersRoute
  '/about': typeof PublicMarketingAboutRoute
  '/accessibility': typeof PublicMarketingAccessibilityRoute
  '/contact': typeof PublicMarketingContactRoute
  '/features': typeof PublicMarketingFeaturesRoute
  '/sync-engine': typeof PublicMarketingSyncEngineRoute
  '/auth/authenticate': typeof PublicAuthAuthenticateRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/auth/mfa': typeof PublicAuthMfaRoute
  '/auth/sign-out': typeof PublicAuthSignOutRoute
  '/auth/unsubscribed': typeof PublicAuthUnsubscribedRoute
  '/$tenantId/$organizationSlug/organization': typeof AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren
  '/docs/operations': typeof PublicContentDocsOperationsRoute
  '/docs/overview': typeof PublicContentDocsOverviewRoute
  '/docs/pages': typeof PublicContentDocsPagesRoute
  '/docs/schemas': typeof PublicContentDocsSchemasRoute
  '/legal/$subject': typeof PublicMarketingLegalSubjectRoute
  '/auth/email-verification/$reason': typeof PublicAuthEmailVerificationReasonRoute
  '/docs/': typeof PublicContentDocsIndexRoute
  '/legal/': typeof PublicMarketingLegalIndexRoute
  '/$tenantId/$organizationSlug/organization/$tool': typeof AppTenantIdOrganizationSlugOrganizationToolRoute
  '/$tenantId/$organizationSlug/organization/attachments': typeof AppTenantIdOrganizationSlugOrganizationAttachmentsRoute
  '/$tenantId/$organizationSlug/organization/members': typeof AppTenantIdOrganizationSlugOrganizationMembersRoute
  '/$tenantId/$organizationSlug/organization/settings': typeof AppTenantIdOrganizationSlugOrganizationSettingsRoute
  '/docs/operations/table': typeof PublicContentDocsOperationsTableRoute
  '/docs/page/$': typeof PublicContentDocsPageSplatRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/system': typeof AppSystemRouteRouteWithChildren
  '/auth': typeof PublicAuthRouteRouteWithChildren
  '/account': typeof AppAccountRoute
  '/home': typeof AppHomeRoute
  '/n': typeof AppNRoute
  '/welcome': typeof AppWelcomeRoute
  '/error': typeof PublicErrorRoute
  '/$tenantId/$organizationSlug': typeof AppTenantIdOrganizationSlugRouteRouteWithChildren
  '/system/$tool': typeof AppSystemToolRoute
  '/system/organizations': typeof AppSystemOrganizationsRoute
  '/system/requests': typeof AppSystemRequestsRoute
  '/system/tenants': typeof AppSystemTenantsRoute
  '/system/users': typeof AppSystemUsersRoute
  '/about': typeof PublicMarketingAboutRoute
  '/accessibility': typeof PublicMarketingAccessibilityRoute
  '/contact': typeof PublicMarketingContactRoute
  '/features': typeof PublicMarketingFeaturesRoute
  '/sync-engine': typeof PublicMarketingSyncEngineRoute
  '/auth/authenticate': typeof PublicAuthAuthenticateRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/auth/mfa': typeof PublicAuthMfaRoute
  '/auth/sign-out': typeof PublicAuthSignOutRoute
  '/auth/unsubscribed': typeof PublicAuthUnsubscribedRoute
  '/$tenantId/$organizationSlug/organization': typeof AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren
  '/docs/operations': typeof PublicContentDocsOperationsRoute
  '/docs/overview': typeof PublicContentDocsOverviewRoute
  '/docs/pages': typeof PublicContentDocsPagesRoute
  '/docs/schemas': typeof PublicContentDocsSchemasRoute
  '/legal/$subject': typeof PublicMarketingLegalSubjectRoute
  '/auth/email-verification/$reason': typeof PublicAuthEmailVerificationReasonRoute
  '/docs': typeof PublicContentDocsIndexRoute
  '/legal': typeof PublicMarketingLegalIndexRoute
  '/$tenantId/$organizationSlug/organization/$tool': typeof AppTenantIdOrganizationSlugOrganizationToolRoute
  '/$tenantId/$organizationSlug/organization/attachments': typeof AppTenantIdOrganizationSlugOrganizationAttachmentsRoute
  '/$tenantId/$organizationSlug/organization/members': typeof AppTenantIdOrganizationSlugOrganizationMembersRoute
  '/$tenantId/$organizationSlug/organization/settings': typeof AppTenantIdOrganizationSlugOrganizationSettingsRoute
  '/docs/operations/table': typeof PublicContentDocsOperationsTableRoute
  '/docs/page/$': typeof PublicContentDocsPageSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_app/system': typeof AppSystemRouteRouteWithChildren
  '/_public/_content': typeof PublicContentRouteRouteWithChildren
  '/_public/auth': typeof PublicAuthRouteRouteWithChildren
  '/_app/account': typeof AppAccountRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/n': typeof AppNRoute
  '/_app/welcome': typeof AppWelcomeRoute
  '/_public/_marketing': typeof PublicMarketingRouteWithChildren
  '/_public/error': typeof PublicErrorRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$tenantId/$organizationSlug': typeof AppTenantIdOrganizationSlugRouteRouteWithChildren
  '/_public/_content/docs': typeof PublicContentDocsRouteRouteWithChildren
  '/_app/system/$tool': typeof AppSystemToolRoute
  '/_app/system/organizations': typeof AppSystemOrganizationsRoute
  '/_app/system/requests': typeof AppSystemRequestsRoute
  '/_app/system/tenants': typeof AppSystemTenantsRoute
  '/_app/system/users': typeof AppSystemUsersRoute
  '/_public/_marketing/about': typeof PublicMarketingAboutRoute
  '/_public/_marketing/accessibility': typeof PublicMarketingAccessibilityRoute
  '/_public/_marketing/contact': typeof PublicMarketingContactRoute
  '/_public/_marketing/features': typeof PublicMarketingFeaturesRoute
  '/_public/_marketing/sync-engine': typeof PublicMarketingSyncEngineRoute
  '/_public/auth/authenticate': typeof PublicAuthAuthenticateRoute
  '/_public/auth/error': typeof PublicAuthErrorRoute
  '/_public/auth/mfa': typeof PublicAuthMfaRoute
  '/_public/auth/sign-out': typeof PublicAuthSignOutRoute
  '/_public/auth/unsubscribed': typeof PublicAuthUnsubscribedRoute
  '/_app/$tenantId/$organizationSlug/organization': typeof AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren
  '/_public/_content/docs/operations': typeof PublicContentDocsOperationsRoute
  '/_public/_content/docs/overview': typeof PublicContentDocsOverviewRoute
  '/_public/_content/docs/pages': typeof PublicContentDocsPagesRoute
  '/_public/_content/docs/schemas': typeof PublicContentDocsSchemasRoute
  '/_public/_marketing/legal/$subject': typeof PublicMarketingLegalSubjectRoute
  '/_public/auth/email-verification/$reason': typeof PublicAuthEmailVerificationReasonRoute
  '/_public/_content/docs/': typeof PublicContentDocsIndexRoute
  '/_public/_marketing/legal/': typeof PublicMarketingLegalIndexRoute
  '/_app/$tenantId/$organizationSlug/organization/$tool': typeof AppTenantIdOrganizationSlugOrganizationToolRoute
  '/_app/$tenantId/$organizationSlug/organization/attachments': typeof AppTenantIdOrganizationSlugOrganizationAttachmentsRoute
  '/_app/$tenantId/$organizationSlug/organization/members': typeof AppTenantIdOrganizationSlugOrganizationMembersRoute
  '/_app/$tenantId/$organizationSlug/organization/settings': typeof AppTenantIdOrganizationSlugOrganizationSettingsRoute
  '/_public/_content/docs/operations_/table': typeof PublicContentDocsOperationsTableRoute
  '/_public/_content/docs/page/$': typeof PublicContentDocsPageSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/system'
    | '/auth'
    | '/account'
    | '/home'
    | '/n'
    | '/welcome'
    | '/error'
    | '/$tenantId/$organizationSlug'
    | '/docs'
    | '/system/$tool'
    | '/system/organizations'
    | '/system/requests'
    | '/system/tenants'
    | '/system/users'
    | '/about'
    | '/accessibility'
    | '/contact'
    | '/features'
    | '/sync-engine'
    | '/auth/authenticate'
    | '/auth/error'
    | '/auth/mfa'
    | '/auth/sign-out'
    | '/auth/unsubscribed'
    | '/$tenantId/$organizationSlug/organization'
    | '/docs/operations'
    | '/docs/overview'
    | '/docs/pages'
    | '/docs/schemas'
    | '/legal/$subject'
    | '/auth/email-verification/$reason'
    | '/docs/'
    | '/legal/'
    | '/$tenantId/$organizationSlug/organization/$tool'
    | '/$tenantId/$organizationSlug/organization/attachments'
    | '/$tenantId/$organizationSlug/organization/members'
    | '/$tenantId/$organizationSlug/organization/settings'
    | '/docs/operations/table'
    | '/docs/page/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/system'
    | '/auth'
    | '/account'
    | '/home'
    | '/n'
    | '/welcome'
    | '/error'
    | '/$tenantId/$organizationSlug'
    | '/system/$tool'
    | '/system/organizations'
    | '/system/requests'
    | '/system/tenants'
    | '/system/users'
    | '/about'
    | '/accessibility'
    | '/contact'
    | '/features'
    | '/sync-engine'
    | '/auth/authenticate'
    | '/auth/error'
    | '/auth/mfa'
    | '/auth/sign-out'
    | '/auth/unsubscribed'
    | '/$tenantId/$organizationSlug/organization'
    | '/docs/operations'
    | '/docs/overview'
    | '/docs/pages'
    | '/docs/schemas'
    | '/legal/$subject'
    | '/auth/email-verification/$reason'
    | '/docs'
    | '/legal'
    | '/$tenantId/$organizationSlug/organization/$tool'
    | '/$tenantId/$organizationSlug/organization/attachments'
    | '/$tenantId/$organizationSlug/organization/members'
    | '/$tenantId/$organizationSlug/organization/settings'
    | '/docs/operations/table'
    | '/docs/page/$'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_app/system'
    | '/_public/_content'
    | '/_public/auth'
    | '/_app/account'
    | '/_app/home'
    | '/_app/n'
    | '/_app/welcome'
    | '/_public/_marketing'
    | '/_public/error'
    | '/_app/'
    | '/_app/$tenantId/$organizationSlug'
    | '/_public/_content/docs'
    | '/_app/system/$tool'
    | '/_app/system/organizations'
    | '/_app/system/requests'
    | '/_app/system/tenants'
    | '/_app/system/users'
    | '/_public/_marketing/about'
    | '/_public/_marketing/accessibility'
    | '/_public/_marketing/contact'
    | '/_public/_marketing/features'
    | '/_public/_marketing/sync-engine'
    | '/_public/auth/authenticate'
    | '/_public/auth/error'
    | '/_public/auth/mfa'
    | '/_public/auth/sign-out'
    | '/_public/auth/unsubscribed'
    | '/_app/$tenantId/$organizationSlug/organization'
    | '/_public/_content/docs/operations'
    | '/_public/_content/docs/overview'
    | '/_public/_content/docs/pages'
    | '/_public/_content/docs/schemas'
    | '/_public/_marketing/legal/$subject'
    | '/_public/auth/email-verification/$reason'
    | '/_public/_content/docs/'
    | '/_public/_marketing/legal/'
    | '/_app/$tenantId/$organizationSlug/organization/$tool'
    | '/_app/$tenantId/$organizationSlug/organization/attachments'
    | '/_app/$tenantId/$organizationSlug/organization/members'
    | '/_app/$tenantId/$organizationSlug/organization/settings'
    | '/_public/_content/docs/operations_/table'
    | '/_public/_content/docs/page/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/n': {
      id: '/_app/n'
      path: '/n'
      fullPath: '/n'
      preLoaderRoute: typeof AppNRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/welcome': {
      id: '/_app/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AppWelcomeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_public/_content': {
      id: '/_public/_content'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicContentRouteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/_marketing': {
      id: '/_public/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicMarketingRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/auth': {
      id: '/_public/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof PublicAuthRouteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/error': {
      id: '/_public/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof PublicErrorRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_app/$tenantId/$organizationSlug': {
      id: '/_app/$tenantId/$organizationSlug'
      path: '/$tenantId/$organizationSlug'
      fullPath: '/$tenantId/$organizationSlug'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/system/$tool': {
      id: '/_app/system/$tool'
      path: '/$tool'
      fullPath: '/system/$tool'
      preLoaderRoute: typeof AppSystemToolRouteImport
      parentRoute: typeof AppSystemRouteRoute
    }
    '/_app/system/organizations': {
      id: '/_app/system/organizations'
      path: '/organizations'
      fullPath: '/system/organizations'
      preLoaderRoute: typeof AppSystemOrganizationsRouteImport
      parentRoute: typeof AppSystemRouteRoute
    }
    '/_app/system/requests': {
      id: '/_app/system/requests'
      path: '/requests'
      fullPath: '/system/requests'
      preLoaderRoute: typeof AppSystemRequestsRouteImport
      parentRoute: typeof AppSystemRouteRoute
    }
    '/_app/system/tenants': {
      id: '/_app/system/tenants'
      path: '/tenants'
      fullPath: '/system/tenants'
      preLoaderRoute: typeof AppSystemTenantsRouteImport
      parentRoute: typeof AppSystemRouteRoute
    }
    '/_app/system/users': {
      id: '/_app/system/users'
      path: '/users'
      fullPath: '/system/users'
      preLoaderRoute: typeof AppSystemUsersRouteImport
      parentRoute: typeof AppSystemRouteRoute
    }
    '/_public/_content/docs': {
      id: '/_public/_content/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof PublicContentDocsRouteRouteImport
      parentRoute: typeof PublicContentRouteRoute
    }
    '/_public/_marketing/about': {
      id: '/_public/_marketing/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicMarketingAboutRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/_marketing/accessibility': {
      id: '/_public/_marketing/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof PublicMarketingAccessibilityRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/_marketing/contact': {
      id: '/_public/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicMarketingContactRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/_marketing/features': {
      id: '/_public/_marketing/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof PublicMarketingFeaturesRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/_marketing/sync-engine': {
      id: '/_public/_marketing/sync-engine'
      path: '/sync-engine'
      fullPath: '/sync-engine'
      preLoaderRoute: typeof PublicMarketingSyncEngineRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/auth/authenticate': {
      id: '/_public/auth/authenticate'
      path: '/authenticate'
      fullPath: '/auth/authenticate'
      preLoaderRoute: typeof PublicAuthAuthenticateRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_public/auth/error': {
      id: '/_public/auth/error'
      path: '/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof PublicAuthErrorRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_public/auth/mfa': {
      id: '/_public/auth/mfa'
      path: '/mfa'
      fullPath: '/auth/mfa'
      preLoaderRoute: typeof PublicAuthMfaRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_public/auth/sign-out': {
      id: '/_public/auth/sign-out'
      path: '/sign-out'
      fullPath: '/auth/sign-out'
      preLoaderRoute: typeof PublicAuthSignOutRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_public/auth/unsubscribed': {
      id: '/_public/auth/unsubscribed'
      path: '/unsubscribed'
      fullPath: '/auth/unsubscribed'
      preLoaderRoute: typeof PublicAuthUnsubscribedRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_app/$tenantId/$organizationSlug/organization': {
      id: '/_app/$tenantId/$organizationSlug/organization'
      path: '/organization'
      fullPath: '/$tenantId/$organizationSlug/organization'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRouteImport
      parentRoute: typeof AppTenantIdOrganizationSlugRouteRoute
    }
    '/_public/_content/docs/': {
      id: '/_public/_content/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof PublicContentDocsIndexRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_content/docs/operations': {
      id: '/_public/_content/docs/operations'
      path: '/operations'
      fullPath: '/docs/operations'
      preLoaderRoute: typeof PublicContentDocsOperationsRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_content/docs/overview': {
      id: '/_public/_content/docs/overview'
      path: '/overview'
      fullPath: '/docs/overview'
      preLoaderRoute: typeof PublicContentDocsOverviewRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_content/docs/pages': {
      id: '/_public/_content/docs/pages'
      path: '/pages'
      fullPath: '/docs/pages'
      preLoaderRoute: typeof PublicContentDocsPagesRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_content/docs/schemas': {
      id: '/_public/_content/docs/schemas'
      path: '/schemas'
      fullPath: '/docs/schemas'
      preLoaderRoute: typeof PublicContentDocsSchemasRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_marketing/legal/': {
      id: '/_public/_marketing/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof PublicMarketingLegalIndexRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/_marketing/legal/$subject': {
      id: '/_public/_marketing/legal/$subject'
      path: '/legal/$subject'
      fullPath: '/legal/$subject'
      preLoaderRoute: typeof PublicMarketingLegalSubjectRouteImport
      parentRoute: typeof PublicMarketingRoute
    }
    '/_public/auth/email-verification/$reason': {
      id: '/_public/auth/email-verification/$reason'
      path: '/email-verification/$reason'
      fullPath: '/auth/email-verification/$reason'
      preLoaderRoute: typeof PublicAuthEmailVerificationReasonRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_app/$tenantId/$organizationSlug/organization/$tool': {
      id: '/_app/$tenantId/$organizationSlug/organization/$tool'
      path: '/$tool'
      fullPath: '/$tenantId/$organizationSlug/organization/$tool'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugOrganizationToolRouteImport
      parentRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRoute
    }
    '/_app/$tenantId/$organizationSlug/organization/attachments': {
      id: '/_app/$tenantId/$organizationSlug/organization/attachments'
      path: '/attachments'
      fullPath: '/$tenantId/$organizationSlug/organization/attachments'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugOrganizationAttachmentsRouteImport
      parentRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRoute
    }
    '/_app/$tenantId/$organizationSlug/organization/members': {
      id: '/_app/$tenantId/$organizationSlug/organization/members'
      path: '/members'
      fullPath: '/$tenantId/$organizationSlug/organization/members'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugOrganizationMembersRouteImport
      parentRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRoute
    }
    '/_app/$tenantId/$organizationSlug/organization/settings': {
      id: '/_app/$tenantId/$organizationSlug/organization/settings'
      path: '/settings'
      fullPath: '/$tenantId/$organizationSlug/organization/settings'
      preLoaderRoute: typeof AppTenantIdOrganizationSlugOrganizationSettingsRouteImport
      parentRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRoute
    }
    '/_public/_content/docs/operations_/table': {
      id: '/_public/_content/docs/operations_/table'
      path: '/operations/table'
      fullPath: '/docs/operations/table'
      preLoaderRoute: typeof PublicContentDocsOperationsTableRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
    '/_public/_content/docs/page/$': {
      id: '/_public/_content/docs/page/$'
      path: '/page/$'
      fullPath: '/docs/page/$'
      preLoaderRoute: typeof PublicContentDocsPageSplatRouteImport
      parentRoute: typeof PublicContentDocsRouteRoute
    }
  }
}

interface AppSystemRouteRouteChildren {
  AppSystemToolRoute: typeof AppSystemToolRoute
  AppSystemOrganizationsRoute: typeof AppSystemOrganizationsRoute
  AppSystemRequestsRoute: typeof AppSystemRequestsRoute
  AppSystemTenantsRoute: typeof AppSystemTenantsRoute
  AppSystemUsersRoute: typeof AppSystemUsersRoute
}

const AppSystemRouteRouteChildren: AppSystemRouteRouteChildren = {
  AppSystemToolRoute: AppSystemToolRoute,
  AppSystemOrganizationsRoute: AppSystemOrganizationsRoute,
  AppSystemRequestsRoute: AppSystemRequestsRoute,
  AppSystemTenantsRoute: AppSystemTenantsRoute,
  AppSystemUsersRoute: AppSystemUsersRoute,
}

const AppSystemRouteRouteWithChildren = AppSystemRouteRoute._addFileChildren(
  AppSystemRouteRouteChildren,
)

interface AppTenantIdOrganizationSlugOrganizationRouteRouteChildren {
  AppTenantIdOrganizationSlugOrganizationToolRoute: typeof AppTenantIdOrganizationSlugOrganizationToolRoute
  AppTenantIdOrganizationSlugOrganizationAttachmentsRoute: typeof AppTenantIdOrganizationSlugOrganizationAttachmentsRoute
  AppTenantIdOrganizationSlugOrganizationMembersRoute: typeof AppTenantIdOrganizationSlugOrganizationMembersRoute
  AppTenantIdOrganizationSlugOrganizationSettingsRoute: typeof AppTenantIdOrganizationSlugOrganizationSettingsRoute
}

const AppTenantIdOrganizationSlugOrganizationRouteRouteChildren: AppTenantIdOrganizationSlugOrganizationRouteRouteChildren =
  {
    AppTenantIdOrganizationSlugOrganizationToolRoute:
      AppTenantIdOrganizationSlugOrganizationToolRoute,
    AppTenantIdOrganizationSlugOrganizationAttachmentsRoute:
      AppTenantIdOrganizationSlugOrganizationAttachmentsRoute,
    AppTenantIdOrganizationSlugOrganizationMembersRoute:
      AppTenantIdOrganizationSlugOrganizationMembersRoute,
    AppTenantIdOrganizationSlugOrganizationSettingsRoute:
      AppTenantIdOrganizationSlugOrganizationSettingsRoute,
  }

const AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren =
  AppTenantIdOrganizationSlugOrganizationRouteRoute._addFileChildren(
    AppTenantIdOrganizationSlugOrganizationRouteRouteChildren,
  )

interface AppTenantIdOrganizationSlugRouteRouteChildren {
  AppTenantIdOrganizationSlugOrganizationRouteRoute: typeof AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren
}

const AppTenantIdOrganizationSlugRouteRouteChildren: AppTenantIdOrganizationSlugRouteRouteChildren =
  {
    AppTenantIdOrganizationSlugOrganizationRouteRoute:
      AppTenantIdOrganizationSlugOrganizationRouteRouteWithChildren,
  }

const AppTenantIdOrganizationSlugRouteRouteWithChildren =
  AppTenantIdOrganizationSlugRouteRoute._addFileChildren(
    AppTenantIdOrganizationSlugRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppSystemRouteRoute: typeof AppSystemRouteRouteWithChildren
  AppAccountRoute: typeof AppAccountRoute
  AppHomeRoute: typeof AppHomeRoute
  AppNRoute: typeof AppNRoute
  AppWelcomeRoute: typeof AppWelcomeRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTenantIdOrganizationSlugRouteRoute: typeof AppTenantIdOrganizationSlugRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSystemRouteRoute: AppSystemRouteRouteWithChildren,
  AppAccountRoute: AppAccountRoute,
  AppHomeRoute: AppHomeRoute,
  AppNRoute: AppNRoute,
  AppWelcomeRoute: AppWelcomeRoute,
  AppIndexRoute: AppIndexRoute,
  AppTenantIdOrganizationSlugRouteRoute:
    AppTenantIdOrganizationSlugRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PublicContentDocsRouteRouteChildren {
  PublicContentDocsOperationsRoute: typeof PublicContentDocsOperationsRoute
  PublicContentDocsOverviewRoute: typeof PublicContentDocsOverviewRoute
  PublicContentDocsPagesRoute: typeof PublicContentDocsPagesRoute
  PublicContentDocsSchemasRoute: typeof PublicContentDocsSchemasRoute
  PublicContentDocsIndexRoute: typeof PublicContentDocsIndexRoute
  PublicContentDocsOperationsTableRoute: typeof PublicContentDocsOperationsTableRoute
  PublicContentDocsPageSplatRoute: typeof PublicContentDocsPageSplatRoute
}

const PublicContentDocsRouteRouteChildren: PublicContentDocsRouteRouteChildren =
  {
    PublicContentDocsOperationsRoute: PublicContentDocsOperationsRoute,
    PublicContentDocsOverviewRoute: PublicContentDocsOverviewRoute,
    PublicContentDocsPagesRoute: PublicContentDocsPagesRoute,
    PublicContentDocsSchemasRoute: PublicContentDocsSchemasRoute,
    PublicContentDocsIndexRoute: PublicContentDocsIndexRoute,
    PublicContentDocsOperationsTableRoute:
      PublicContentDocsOperationsTableRoute,
    PublicContentDocsPageSplatRoute: PublicContentDocsPageSplatRoute,
  }

const PublicContentDocsRouteRouteWithChildren =
  PublicContentDocsRouteRoute._addFileChildren(
    PublicContentDocsRouteRouteChildren,
  )

interface PublicContentRouteRouteChildren {
  PublicContentDocsRouteRoute: typeof PublicContentDocsRouteRouteWithChildren
}

const PublicContentRouteRouteChildren: PublicContentRouteRouteChildren = {
  PublicContentDocsRouteRoute: PublicContentDocsRouteRouteWithChildren,
}

const PublicContentRouteRouteWithChildren =
  PublicContentRouteRoute._addFileChildren(PublicContentRouteRouteChildren)

interface PublicAuthRouteRouteChildren {
  PublicAuthAuthenticateRoute: typeof PublicAuthAuthenticateRoute
  PublicAuthErrorRoute: typeof PublicAuthErrorRoute
  PublicAuthMfaRoute: typeof PublicAuthMfaRoute
  PublicAuthSignOutRoute: typeof PublicAuthSignOutRoute
  PublicAuthUnsubscribedRoute: typeof PublicAuthUnsubscribedRoute
  PublicAuthEmailVerificationReasonRoute: typeof PublicAuthEmailVerificationReasonRoute
}

const PublicAuthRouteRouteChildren: PublicAuthRouteRouteChildren = {
  PublicAuthAuthenticateRoute: PublicAuthAuthenticateRoute,
  PublicAuthErrorRoute: PublicAuthErrorRoute,
  PublicAuthMfaRoute: PublicAuthMfaRoute,
  PublicAuthSignOutRoute: PublicAuthSignOutRoute,
  PublicAuthUnsubscribedRoute: PublicAuthUnsubscribedRoute,
  PublicAuthEmailVerificationReasonRoute:
    PublicAuthEmailVerificationReasonRoute,
}

const PublicAuthRouteRouteWithChildren = PublicAuthRouteRoute._addFileChildren(
  PublicAuthRouteRouteChildren,
)

interface PublicMarketingRouteChildren {
  PublicMarketingAboutRoute: typeof PublicMarketingAboutRoute
  PublicMarketingAccessibilityRoute: typeof PublicMarketingAccessibilityRoute
  PublicMarketingContactRoute: typeof PublicMarketingContactRoute
  PublicMarketingFeaturesRoute: typeof PublicMarketingFeaturesRoute
  PublicMarketingSyncEngineRoute: typeof PublicMarketingSyncEngineRoute
  PublicMarketingLegalSubjectRoute: typeof PublicMarketingLegalSubjectRoute
  PublicMarketingLegalIndexRoute: typeof PublicMarketingLegalIndexRoute
}

const PublicMarketingRouteChildren: PublicMarketingRouteChildren = {
  PublicMarketingAboutRoute: PublicMarketingAboutRoute,
  PublicMarketingAccessibilityRoute: PublicMarketingAccessibilityRoute,
  PublicMarketingContactRoute: PublicMarketingContactRoute,
  PublicMarketingFeaturesRoute: PublicMarketingFeaturesRoute,
  PublicMarketingSyncEngineRoute: PublicMarketingSyncEngineRoute,
  PublicMarketingLegalSubjectRoute: PublicMarketingLegalSubjectRoute,
  PublicMarketingLegalIndexRoute: PublicMarketingLegalIndexRoute,
}

const PublicMarketingRouteWithChildren = PublicMarketingRoute._addFileChildren(
  PublicMarketingRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicContentRouteRoute: typeof PublicContentRouteRouteWithChildren
  PublicAuthRouteRoute: typeof PublicAuthRouteRouteWithChildren
  PublicMarketingRoute: typeof PublicMarketingRouteWithChildren
  PublicErrorRoute: typeof PublicErrorRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicContentRouteRoute: PublicContentRouteRouteWithChildren,
  PublicAuthRouteRoute: PublicAuthRouteRouteWithChildren,
  PublicMarketingRoute: PublicMarketingRouteWithChildren,
  PublicErrorRoute: PublicErrorRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
